import { Injectable, signal } from '@angular/core';
import { AppSettings, defaults } from '../../config';

const STORAGE_KEY = 'app-options';


function loadInitial(): AppSettings {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return defaults;
    const saved = JSON.parse(raw);
    
    if (saved.horizontal === undefined) {
      return { ...defaults, ...saved, horizontal: true, navPos: 'top' , boxed: false};
    }
    return { ...defaults, ...saved };
  } catch {
    return defaults;
  }
}

@Injectable({
  providedIn: 'root',
})
export class CoreService {
  private optionsSignal = signal<AppSettings>(loadInitial());

  // expose readonly signal so templates/components can read reactively
  readonly options = this.optionsSignal.asReadonly();

  getOptions() {
    return this.optionsSignal();
  }

  setOptions(options: Partial<AppSettings>) {
    this.optionsSignal.update((current) => {
      const next = { ...current, ...options };
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      return next;
    });
  }

  setLanguage(lang: string) {
    this.setOptions({ language: lang });
  }

  getLanguage() {
    return this.getOptions().language;
  }
}
